import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class ConfigureManage {
  // 获取组态列表
  static async getConfigureList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/three_dimensional_configure/query_list/?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 新增组态
  static async insertConfigure(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/basedata/three_dimensional_configure/insert', payload)
    )
    return Callback(err, res)
  }
  // 编辑组态
  static async updateConfigure(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/basedata/three_dimensional_configure/update', payload)
    )
    return Callback(err, res)
  }
  // 删除组态
  static async deleteConfigure(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/Three_Dimensional_Configure/three_dimensional_configure', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 导入组态
  static async uploadConfigure(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/Three_Dimensional_Configure/three_dimensional_configure/import',
        payload.formData
      )
    )
    return Callback(err, res)
  }
  // 导出组态
  static async exportExcel(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Three_Dimensional_Configure_Detail/export_list', payload)
    )
    return Callback(err, res)
  }

  // 新增组态对象
  static async insertConfigureDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/Three_Dimensional_Configure_Detail/three_dimensional_configure_detail/insert',
        payload
      )
    )
    return Callback(err, res)
  }
  // 获取组态对象列表
  static async getConfigureDetailList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Three_Dimensional_Configure_Detail/query_list/?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 删除组态对象
  static async deleteConfigureDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete(
        '/api/Three_Dimensional_Configure_Detail/three_dimensional_configure_detail',
        { data: payload }
      )
    )
    return Callback(err, res)
  }
}
